import { render, staticRenderFns } from "./Company_stats.vue?vue&type=template&id=6e5fc4d4&scoped=true&lang=pug&"
import script from "./Company_stats.vue?vue&type=script&lang=coffee&"
export * from "./Company_stats.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5fc4d4",
  null
  
)

export default component.exports